import css from './LogoWithVideo.module.scss';

const LogoWithVideo = () => {
    return (
        <div className={css.logoBigWrapper}>
            <div className={css.logoBig}>
                <p className={css.videoText}>Global Trend</p>
            </div>
        </div>
    );
};

export default LogoWithVideo;
